<template>
  <a-spin :spinning="spinning" class="spin-wrap">
    <div ref="gamePlayer" class="game-player" />
  </a-spin>
</template>

<script>
import { GamePlayerSDK, IEventName } from 'axx-slide-game-sdk'
import videoService from '@/service/video/index'
export default {
  data() {
    return {
      spinning: false
    }
  },
  mounted() {
    this.sdk = new GamePlayerSDK()
  },
  methods: {
    initListeners(game) {
      game.addListener(IEventName.OnGameLoad, data => {
        console.log('游戏加载完成', data)
        this.$emit('onGameLoad', data)
      })
      game.addListener(IEventName.OnGamePlaySubmit, data => {
        console.log('游戏提交', data)
        setTimeout(() => {
          this.$emit('onGamePlaySubmit', data)
        }, 400)
      })
    },
    getSign() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({
            succeed: true,
            cwSign: '8121efb0cfae163ce83c97b47bfe1281',
            cwExpired: 1668678519206,
            cwPf: 'sg_itv',
            cwUser: '46310',
            cwData: '31O33F92459'
          })
        }, 800)
      })
    },
    async loadGame(params) {
      console.log('params', params.selectIds)
      const { uri } = params.selectIds[0]
      this.spinning = true
      const container = this.$refs.gamePlayer
      const body = await videoService.getGaopinSign({ cwData: uri })
      const gameData = { id: uri, params: { autoplaybgm: false, hideStartPage: 1, ...body } }
      const game = this.sdk.load(container, gameData)
      this.initListeners(game)
      this.spinning = false
    }
  }
}
</script>

<style lang="less" scoped>
.spin-wrap {
  width: 100%;
  height: 100%;
  :deep(.ant-spin-container) {
    width: 100%;
    height: 100%;
  }
  :deep(.ant-spin) {
    max-height: 100%;
  }
  :deep(.ant-spin-dot-item) {
    background-color: #fff;
  }
}
.game-player {
  width: 100%;
  height: 100%;
  :deep(.out-container) {
    width: 101% !important;
  }
}
</style>